import LayoutGrid from "@components/HomeMain/LayoutGrid";
import { homeStateSelector } from "@store/redux/modules/home";
import { useDispatch, useSelector } from "react-redux";
import CurrentWeather from "../CurrentWeather";
import WarningWeather from "../WarningWeather";
import Hour from "../Hour";
import RecentWeather from "../RecentWeather";
import ChartData from "../ChartData";
import Sunrise from "../Sunrise";
import { refreshUserLocation } from "@/components/BasicLayout/BasicHeader/LocationMask";
import { useActivate, useUnactivate } from "react-activation";
import { Skeleton } from "antd-mobile";
import { getWeatherDomainType, isTestLink } from "@/utils";
import lodash from "lodash";
const HomeDefault: React.FC = () => {
  const dispatch = useDispatch();
  const homeState = useSelector(homeStateSelector);
  const { current, forecast5day = [], aqi, forecast24hour = [] } = homeState;
  useEffect(() => {
    const asyncRefresh = async () => {
      refreshUserLocation(dispatch);
    };
    asyncRefresh();
  }, []);

  useActivate(() => {
    console.log("Home组件已激活");
  });
  useUnactivate(() => {
    console.log("Home组件已缓存");
  });
  const weatherSections: any = [
    <>
      {isEmptyType(forecast24hour) ? (
        <Skeleton
          animated
          style={{
            "--width": "100%",
            "--height": "198px",
            "--border-radius": "10px",
          }}
        />
      ) : (
        <Hour />
      )}
      {(isTestLink(lodash.flatten(Object.values(lodash.omit(domainMap, ["wi"])))) ||
        lodash.flatten(Object.values(lodash.omit(domainMap, ["wi"]))).includes(window.location.hostname)) && (
        <GoogleAd {...useGoogleAd("300x250", 1)} />
      )}
    </>,
    <>
      {isEmptyType(forecast5day) ? (
        <Skeleton
          animated
          style={{
            "--width": "100%",
            "--height": "387px",
            "--border-radius": "10px",
          }}
        />
      ) : (
        <RecentWeather />
      )}
      {(isTestLink(lodash.flatten(Object.values(lodash.omit(domainMap, ["wi"])))) ||
        lodash.flatten(Object.values(lodash.omit(domainMap, ["wi"]))).includes(window.location.hostname)) && (
        <GoogleAd {...useGoogleAd("300x250", 2)} />
      )}
    </>,
  ];
  const additionalSections = [
    isEmptyType(aqi) ? (
      <Skeleton
        animated
        style={{
          "--width": "100%",
          "--height": "188px",
          "--border-radius": "10px",
        }}
      />
    ) : (
      <ChartData />
    ),
    isEmptyType(current) ? (
      <Skeleton
        animated
        style={{
          "--width": "100%",
          "--height": "121px",
          "--border-radius": "10px",
        }}
      />
    ) : (
      <Sunrise />
    ),
  ];
  return (
    <div className="flex flex-col justify-start gap-y-10 p-[0_16px] box-border">
      {(isTestLink(domains) || domains.includes(window.location.hostname)) && (
        <GoogleAd {...useGoogleAd("320x100", 0)} />
      )}
      {isEmptyType(current) ? (
        <Skeleton
          animated
          style={{
            "--width": "100%",
            "--height": "233px",
            "--border-radius": "10px",
          }}
        />
      ) : (
        <CurrentWeather />
      )}
      {isEmptyType(current) ? (
        <Skeleton
          animated
          style={{
            "--width": "100%",
            "--height": "50px",
            "--border-radius": "10px",
          }}
        />
      ) : (
        <WarningWeather />
      )}
      {getWeatherDomainType() === "24hweather.com" ? (
        <>
          {weatherSections[1]}
          {weatherSections[0]}
        </>
      ) : (
        <>
          {weatherSections[0]}
          {weatherSections[1]}
        </>
      )}

      {isEmptyType(current) ? (
        <Skeleton
          animated
          style={{
            "--width": "100%",
            "--height": "839px",
            "--border-radius": "10px",
          }}
        />
      ) : (
        !!current?.Items?.length && <LayoutGrid list={current.Items} />
      )}
      {(isTestLink(lodash.flatten(Object.values(lodash.omit(domainMap, ["wi"])))) ||
        lodash.flatten(Object.values(lodash.omit(domainMap, ["wi"]))).includes(window.location.hostname)) && (
        <GoogleAd {...useGoogleAd("300x250", 3)} />
      )}
      {getWeatherDomainType() === "24hweather.com" ? (
        <>
          {additionalSections[1]}
          {additionalSections[0]}
        </>
      ) : (
        <>
          {additionalSections[0]}
          {additionalSections[1]}
        </>
      )}
    </div>
  );
};
export default HomeDefault;
